import { render, staticRenderFns } from "./settings-user-mapping-stat-card.vue?vue&type=template&id=31f84346&scoped=true"
import script from "./settings-user-mapping-stat-card.vue?vue&type=script&lang=js"
export * from "./settings-user-mapping-stat-card.vue?vue&type=script&lang=js"
import style0 from "./settings-user-mapping-stat-card.vue?vue&type=style&index=0&id=31f84346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f84346",
  null
  
)

export default component.exports